import { AES, enc } from "crypto-js"
import KwilDB from "kwildb"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import FundingView from "../components/FundingView"
import NavBar from "../components/NavBar"
import TableView from "../components/TableView"
import { addNewMoat } from "../redux/slices/moatNameSlice"
import "../styling/Home.css"


export default function Home() {
    const address = localStorage.getItem("address")
    const dispatch = useDispatch()

    const schemaName = useSelector((state) => state.toggleControl.schema)
    const tableName = useSelector((state) => state.toggleControl.table)
    const selectedPools = useSelector((state) => state.toggleControl.selectedPool)
    const initialPools = useRef(selectedPools)
    const initialSchema = useRef(schemaName)
    const initialTable = useRef(tableName)
    const [update, setUpdate] = useState(0)


    useEffect(() => {
        setTimeout(async function () {
            const temp = await KwilDB.getMoats(
                "https://test-db.kwil.xyz",
                address
            )
            dispatch(addNewMoat(temp))
        })
    })

    const privKey = AES.decrypt(
        useSelector((state) => state.privateKey.value),
        "kwil"
      ).toString(enc.Utf8);

      const secret = AES.decrypt(
        useSelector((state) => state.secret.value), "kwil"
      ).toString(enc.Utf8)


    return (
        <div className="home-background">
            <NavBar 
                initialTable={initialTable}
                initialSchema={initialSchema}
                update={update}
                setUpdate={setUpdate}
                initialPools={initialPools}
                privKey={privKey}
                secret={secret}
            />
            <div className="home-right">
                {tableName &&
                    <TableView
                        tableName={tableName}
                        schemaName={schemaName}
                        privKey={privKey}
                        secret={secret}
                />}
                {selectedPools.length > 0 &&
                    <FundingView
                        selectedPools={selectedPools}
                        privKey={privKey}
                        secret={secret}
                        update={update}
                />}
            </div>
        </div>
    )
}